// @ts-nocheck

import React, { useContext } from 'react';
import { Group } from 'react-konva';

import { __ } from '../../../i18n/l10n';
import BetshareContext from '../contexts/BetshareContext';
import { getRelativeValue } from '../utils';

import TextWithBackground from './TextWithBackground';

const SystemHeader = (props) => {
  const { x, y, combinations, forwardRef } = props;
  const { stageWidth } = useContext(BetshareContext);

  return (
    <Group x={x} y={y} ref={forwardRef}>
      <TextWithBackground
        x={0}
        y={getRelativeValue(4, stageWidth)}
        width={stageWidth}
        text={`${__('Multiples:').toUpperCase()} ${combinations.join('  |  ')}`}
        paddingTopBottom={getRelativeValue(4, stageWidth)}
        marginBottom={getRelativeValue(1, stageWidth)}
        backgroundColor="#f1f1f1"
        fontFamily="BettingPoliticaExtraBold, sans-serif"
        fontSize={getRelativeValue(10, stageWidth)}
        lineHeight={1.2}
        fill="#393838"
        align="center"
      />
    </Group>
  );
};

export default SystemHeader;
